import { AS_GD_ASYNC, AS_O365_ASYNC, DATA_REQUEST_ASYNC, SEGMENTS_REQUEST_ASYNC } from './constants'

const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})

export const fetchSegments = () => ({ type: SEGMENTS_REQUEST_ASYNC.INITIATE })
export const fetchSegmentsSuccess = (data) => ({
  type: SEGMENTS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchSegmentsCancel = () => ({
  type: SEGMENTS_REQUEST_ASYNC.CANCEL,
})

export const asO365 = (body) => ({
  type: AS_O365_ASYNC.INITIATE,
  payload: { body },
})
export const asO365Success = (data) => ({
  type: AS_O365_ASYNC.SUCCESS,
  payload: { data },
})
export const asO365Cancel = () => ({ type: AS_O365_ASYNC.CANCEL })

export const asGD = (body) => ({
  type: AS_GD_ASYNC.INITIATE,
  payload: { body },
})
export const asGDSuccess = (data) => ({
  type: AS_GD_ASYNC.SUCCESS,
  payload: { data },
})
export const asGDCancel = () => ({ type: AS_GD_ASYNC.CANCEL })

export default {
  // to props
  fetchData,
  fetchDataCancel,
}
